<template>
    <button type="button" class="btn btn-primary mt-2" v-on:click="modalOpen">Add User</button>
    <button type="button" class="d-none" data-toggle="modal" data-target=".usersModals" id="addUserBtn"> </button>
    <div class="modal fade usersModals" id="userModalId" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalType }} User</h5>
                    <button type="button" class="close" id="closePop" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <span v-if="errorMessage != ''">
                                <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                            </span>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="teamName">Name:</label>
                            <input type="text" class="form-control" name="teamName" id="teamName" placeholder="Enter name"  v-model="v$.form.teamName.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.teamName.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="teamEmail">Email:</label>
                            <input type="email" class="form-control" name="teamEmail" id="teamEmail" placeholder="Enter email"  v-model="v$.form.teamEmail.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.teamEmail.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6" v-if="modalType == 'Add'">
                            <label for="teamPassword">Password:</label>
                            <input type="password" class="form-control" name="teamPassword" id="teamPassword" placeholder="Enter password"  v-model="v$.form.teamPassword.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.teamPassword.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6" v-else>
                            <label for="passwordEdit">Password:</label>
                            <input type="password" class="form-control" name="passwordEdit" id="passwordEdit" placeholder="Enter password"  v-model="v$.form.passwordEdit.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.passwordEdit.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="roleDropId" >Role<span class="requiredCls">*</span></label>
                            <Select2 v-model="v$.form.role_id.$model" v-bind:id="'roleDropId'" :options="$store.state.role.RoleList" :placeholder="'Select Role'" class=""/>
                        </div>
                        <div class="form-group col-md-12 uploadshrtcls">
                                <label for="user_image" >User Image</label>
                                <div class="upload-btn-wrapper">
                                    <div class="formmginput-controlx_inner fileintset setfileupload d-flex justify-content-between">
                                        <input type="file" class="form-control" name="user_image" id="user_image" accept="image/png, image/gif, image/jpeg" @change="readURL()">Upload a file
                                        <div class="iq-avatars d-flex flex-wrap align-items-center">
                                            <img id="blah" src="../../assets/images/No_image_available.svg.png" alt="logo image" class="avatar-40 rounded" />
                                            <input type="hidden" value="../assets/No_image_available.svg.png" id="imgVal" />
                                        </div>
                                    </div> 
                                </div>      
                            <!-- <div class="input-errors">
                                <div class="error-msg  nonecls" id="imgErrorCls">Please select image</div>
                            </div> -->
                        </div>      
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary cancel" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary" :disabled="v$.form.$invalid" v-on:click="addUser" v-if="formLoader === 1">{{ buttonName }}</button>
                    <button type="button" class="btn btn-primary" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Select2 from 'vue3-select2-component';
import useVuelidate from '@vuelidate/core'
// import axios from 'axios'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'

import {
    email,
    required,
    // maxLength,
    minLength
} from '@vuelidate/validators'
import 
    { postCommon } 
from '../../utils/api.js'
import noImgAvailable from '../../assets/images/No_image_available.svg.png'
import $ from "jquery";
    export default {
        name: 'AddEditUsersPage',
        emits: ['reload-table-data'],
        components: {
            Select2,
        },
        data() {
            return {
                modalType: 'Add',
                buttonName: 'Save',
                errorMessage: '',
                formLoader: 1,
                logoFile: null,
                img_url: process.env.VUE_APP_IMG_URL,
                form: {
                    teamName: '',
                    teamEmail: '',
                    teamPassword: '',
                    role_id: '',
                    user_image: '',
                    password: '',
                    passwordEdit: '',
                },
            }
        },
        methods: {
            startLoader,
            finishLoader,
            async modalOpen() {
                this.errorMessage = ''
                this.form.teamName = '';
                this.form.teamEmail = '';
                this.form.password = '';
                this.v$.form.teamPassword.$model = ''
                this.form.passwordEdit = '';
                this.form.role_id = '';
                this.modalType = 'Add';
                this.buttonName = 'Save',
                this.logoFile = null,
                this.v$.$reset()
                document.getElementById('blah').src = noImgAvailable;
                document.getElementById('user_image').value = '';
                document.getElementById('addUserBtn').click();
                setTimeout(async () =>
                    $("#teamName").focus(),
                500);
            },
            async modalEditOpen() {
                this.startLoader();
                let team_id = $('.teamValId').val();
                this.errorMessage = ''
                this.form.teamName = '';
                this.form.lastName = '';
                this.form.teamEmail = '';
                this.form.passwordEdit = '';
                this.modalType = 'Edit',
                this.buttonName = 'Update',
                document.getElementById('teamName').value = '';
                document.getElementById('teamEmail').value = '';
                this.v$.$reset()
                this.formLoader = 2

                let _post = {}
                _post = {
                    user_id: team_id
                }

                const resp = await postCommon('user/get', _post)
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('teamName').value = resp.data.data.name;
                    document.getElementById('teamEmail').value = resp.data.data.email;
                    document.getElementById('roleDropId').value = resp.data.data.role_id;
                    document.getElementById('teamEditId').value = resp.data.data._id;
                    this.v$.form.teamName.$model = resp.data.data.name;
                    this.v$.form.teamPassword.$model = resp.data.data.email;
                    this.v$.form.teamEmail.$model = resp.data.data.email;
                    this.v$.form.role_id.$model = resp.data.data.role_id;
                    document.getElementById('blah').src = this.img_url + '' + resp.data.data.user_image
                    document.getElementById('addUserBtn').click();
                    this.v$.$reset()
                    this.finishLoader();
                    setTimeout(async () =>
                        $("#teamName").focus(),
                    500);
                }
                this.formLoader = 1
            },
            async addUser() {
                this.formLoader = 2
                let _URL = ''
                
                const fd = new FormData;

                var teamName = $('#teamName').val();
                var teamEmail = $('#teamEmail').val();
                var passwordEdit = $('#passwordEdit').val();
                var teamPassword = $('#teamPassword').val();
                var roleDropId = $('#roleDropId').val();

                fd.append('name', teamName)
                fd.append('email', teamEmail)
                fd.append('role_id', roleDropId)
                fd.append('user_image', this.logoFile)
                // let _post = {}
                if (this.modalType == 'Edit') {
                    _URL = 'user/update'       
                    if(passwordEdit){
                        fd.append('password', passwordEdit)         
                    }
                    fd.append('user_id', $('#teamEditId').val())    
                } else {
                    _URL = 'user/create'
                    fd.append('password', teamPassword)    
                }
                const resp = await postCommon(_URL, fd)

                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                    this.$toast.error(resp.data.message);
                }
                    this.formLoader = 1
            },
            readURL() {
                this.logoFile = document.getElementById('user_image').files[0]
                var selectedFile = document.getElementById('user_image').files[0];
                var img = document.getElementById('blah')
                var reader = new FileReader();
                reader.onload = function () {
                    img.src = this.result
                }
                this.isNewImg = 1;
                // document.getElementById('imgErrorCls').style.display = 'none';

                if(selectedFile){
                    reader.readAsDataURL(selectedFile);
                }

            },
        },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                teamName: {
                    required,
                    min: minLength(2)
                },
                teamEmail: {
                    email,
                    required,
                },
                teamPassword: {
                    required,
                    min: minLength(8)
                },
                role_id: {
                    required,
                },
                passwordEdit: {
                    min: minLength(8)
                },
            },
        }
    },
    }
</script>
